<template>
  <div>
    <section v-if="__displayMode === displayModeEnum.SINGLE" id="prizes_carousel">
      <h1 v-if="showTitle"> {{ getTranslations.home_carousel_title }} </h1>

      <div class="prize_single_img">
        <prize-single-display-mode-image></prize-single-display-mode-image>

        <div class="prize_title">{{ getTranslations.prize_section_single_type_title }}</div>

        <div class="prize_desc">{{ getTranslations.prize_section_single_type_description }}</div>
      </div>
    </section>

    <carousel v-else-if="__displayMode === displayModeEnum.CAROUSEL" :show-title="showTitle"></carousel>
  </div>

</template>

<script>
import {mapGetters, mapState} from 'vuex'
import PrizeSingleDisplayModeImage from '../image/PrizeSingleDisplayModeImage'
import Carousel from '../../home/Carousel'
import {prizeDisplayModeEnum} from '../../../constants/prizes'

export default {
  name: 'PrizeSection',
  components: {
    PrizeSingleDisplayModeImage,
    Carousel
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    displayMode: {
      type: String,
      default: '',
      validator: function (value) {
        return !value || Object.values(prizeDisplayModeEnum).includes(value)
      }
    }
  },
  data () {
    return {
      displayModeEnum: prizeDisplayModeEnum
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    ...mapState('common', [
      'prizeDisplayMode'
    ]),
    __displayMode () {
      return this.displayMode || this.prizeDisplayMode
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/section/PrizeSection.vue